import React, {Component} from "react"

import {perkbox} from "@irati/ui/src/global/colors"
import {H6} from "@irati/ui/src/Typography"

import {StyledNav, StyledNavItem} from "./styled"
import {Tab} from "../index"

interface Props {
  tabs: Tab[],
  fullWidth?: boolean,
  activeColor?: string
}

export default class Headers extends Component<Props> {
  static defaultProps = {
    fullWidth: false,
    activeColor: perkbox.blue
  }

  render() {
    const {tabs, fullWidth, activeColor} = this.props

    return (
      <StyledNav bsStyle="pills">
        {tabs.map(({key, title}) => (
          <StyledNavItem fullWidth={fullWidth} activeColor={activeColor} key={key} eventKey={key}>
            <H6>{title}</H6>
          </StyledNavItem>
        ))}
      </StyledNav>
    )
  }
}
